import React, { useState } from "react";
import { Box } from "@mui/material";
import LGCrud from "../LGCrud";
import LGModal from "../../molecules/LGModal";
import { useSnack } from "../../services/SnakbarProvider";
import { handleError } from "../../services/errorHandler";
import {
  createClient,
  getClientList,
  updateClient,
  deleteClient,
} from "../../api/client";
import ClientAddressList from "./ClientAddressList";

export default function CrudClient({ companyId }: { companyId: number }): JSX.Element {
  const { openSnack } = useSnack();
  const [addressModalOpen, setAddressModalOpen] = useState(false);
  const [selectedClientId, setSelectedClientId] = useState<number | null>(null);

  const handlePost = async (data) => {
    const payload = {
      companyId,
      ...data,
    };
    try {
      await createClient(payload);
      openSnack("Cliente guardado con éxito", "success");
    } catch (e) {
      openSnack(handleError(e), "error");
    }
  };

  const handleUpdate = async (id, data) => {
    const payload = {
      ...data,
    };
    try {
      await updateClient(id, payload);
      openSnack("Cliente actualizado con éxito", "success");
    } catch (e) {
      openSnack(handleError(e), "error");
    }
  };

  const handleDelete = async (id) => {
    await deleteClient(id);
  };

  const handleOpenAddresses = (_event, id) => {
    setSelectedClientId(id);
    setAddressModalOpen(true);
  };

  const handleCloseAddressModal = () => {
    setAddressModalOpen(false);
    setSelectedClientId(null);
  };

  return (
    <>
      <LGModal
        open={addressModalOpen}
        header="Direcciones del cliente"
        handleClose={handleCloseAddressModal}
      >
        {selectedClientId && (
          <ClientAddressList
            clientId={selectedClientId}
            companyId={companyId}
          />
        )}
      </LGModal>
      <Box width={"100%"}>
        <LGCrud
          columns={[
            {
              field: "name",
              headerName: "Nombre",
              flex: 0.7,
              editable: true,
            },
            {
              field: "code",
              headerName: "Clave",
              flex: 0.3,
              editable: true,
            },
          ]}
          parentId={{
            name: "companyId",
            value: companyId,
          }}
          actionHandlers={{
            create: handlePost,
            update: handleUpdate,
            delete: handleDelete,
            fetchData: getClientList,
            onDetail: handleOpenAddresses,
          }}
        />
      </Box>
    </>
  );
}
